import { isLicensedTo, windowReady } from '@/general'
import Vue from '@/vue'
import { defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import SidebarBottomNav from '@/components/layout/SidebarBottomNav.vue'
import OrderCountBadge from '@/global/OrderCountBadge.vue'

windowReady(() => {
  if (
    window.location.pathname.includes('login') ||
    window.location.pathname.includes('two-factor-setup')
  ) {
    import('@/auth/index')
  }

  if (window.location.pathname.includes('relations')) {
    import('@/modules/relations/relations.module')
  }

  if (window.location.pathname.includes('relation-groups')) {
    import('@/modules/relation-groups/relation-group.module')
  }

  if (isLicensedTo('hours') && window.location.pathname.includes('hour-type')) {
    import('@/modules/hours/hours.module')
  }

  if (isLicensedTo('crm') && window.location.pathname.includes('file-templates')) {
    import('@/modules/file-templates/file-templates.module')
  }

  if (
    isLicensedTo('hours') &&
    window.location.pathname.includes('time-registrations')
  ) {
    import('@/modules/time-registrations/time-registrations.module')
  }

  if (window.location.pathname.includes('cockpits')) {
    import('@/../sass/pages/cockpits.scss')

    import('@/modules/cockpits')
  }

  if (window.location.pathname.includes('other/users')) {
    import('@/modules/users/users.module')
  }

  if (window.location.pathname.includes('other/roles')) {
    import('@/modules/users/roles.module')
  }

  if (window.location.pathname.includes('companies')) {
    import('@/modules/companies')
  }

  if (
    window.location.pathname.includes('planning-orders') ||
    window.location.pathname.includes('plannables')
  ) {
    import('@/modules/planning-orders/planning-orders.module')
    import('@/modules/plannables/plannables.module')
  }

  if (['/planning', '/planning/archive'].includes(window.location.pathname)) {
    import('@/modules/planning/planning.module')
  }

  if (
    ['/planning', '/planning/archive'].includes(window.location.pathname) ||
    window.location.pathname.includes('planning-orders') ||
    window.location.pathname.includes('plannables') ||
    window.location.pathname.includes('designer')
  ) {
    import('@/../sass/pages/planning.scss')
  }

  if (window.location.pathname === '/planning') {
    import('@/modules/planning/planning.module')
  }

  if (window.location.pathname.includes('planboards')) {
    import('@/modules/planboards/planboards')
  }

  if (
    window.location.pathname.includes('products') ||
    window.location.pathname.includes('product-categories')
  ) {
    import('@/modules/products')
  }

  if (window.location.pathname.includes('tenants')) {
    import('@/modules/tenants/index')
  }

  if (window.location.pathname.includes('tags')) {
    import('@/modules/tags/tags.module')
  }

  if (window.location.pathname.includes('machines')) {
    import('@/modules/machines')
  }

  if (window.location.pathname.includes('vat')) {
    import('@/modules/vats/vats.module')
  }

  if (window.location.pathname.includes('countries')) {
    import('@/modules/countries/countries.module')
  }

  if (window.location.pathname.includes('activities')) {
    import('@/modules/activities/activities.module')
  }

  if (window.location.pathname.includes('employees')) {
    import('@/modules/employees/employees.module')
  }

  if (window.location.pathname.includes('occupation')) {
    import('@/modules/occupations/occupation.module')
  }

  if (window.location.pathname.includes('payment-periods')) {
    import('@/modules/payment-periods')
  }

  if (window.location.pathname.includes('settings')) {
    import('@/modules/settings/settings.module')
  }

  if (window.location.pathname.includes('profile')) {
    import('@/modules/profile/profile.module')
  }

  if (window.location.pathname.includes('applications')) {
    import('@/modules/applications/applications.module')
  }

  if (window.location.pathname.includes('breaktimes')) {
    import('@/modules/break-times/break-times.module')
  }

  if (isLicensedTo('crm') && window.location.pathname.includes('quotation')) {
    import('@/modules/quotations/quotations.module')
  }

  if (window.location.pathname.includes('industries')) {
    import('@/modules/industries/industries.module')
  }

  if (
    isLicensedTo('orders') &&
    (window.location.pathname.includes('orders') || window.location.pathname.includes('man-day-timesheets'))
  ) {
    import('@/modules/orders/orders.module')
  }

  if (isLicensedTo('invoices')) {
    if (window.location.pathname.includes('invoices/export')) {
      import('@/modules/invoice-exports/invoice-exports.module')
    }

    if (window.location.pathname.includes('invoices/export/batch')) {
      import('@/modules/invoice-export-batches')
    }

    if (window.location.pathname.includes('invoice-export-configs')) {
      import('@/modules/invoice-exports-config/invoice-exports-config.module')
    }

    if (
      window.location.pathname.includes('invoices') ||
      window.location.pathname.includes('relations')
    ) {
      import('@/modules/invoices/invoices.module')
    }

    if (window.location.pathname.includes('surcharges')) {
      import('@/modules/surcharges/surcharges.module')
    }

    if (window.location.pathname.includes('surcharge-categories')) {
      import('@/modules/surcharge-categories/surcharge-categories.module')
    }
  }

  if (
    window.location.pathname.includes('numberings') ||
    window.location.pathname.includes('companies')
  ) {
    import('@/modules/numberings/numberings.module')
  }

  if (window.location.pathname.includes('units')) {
    import('@/modules/units/units.module')
  }

  if (window.location.pathname.includes('archive-types')) {
    import('@/modules/archives/archives.module')
  }

  if (
    window.location.pathname.includes('changelogs') &&
    document.getElementById('changelog-overview')
  ) {
    const pinia = createPinia()

    new Vue({
      el: '#changelog-overview',
      pinia,
      components: {
        ChangelogOverview: defineAsyncComponent(() => import('@/modules/changelogs/ChangelogOverview.vue'))
      }
    })
  }

  if (document.getElementById('release-notes-page')) {
    const pinia = createPinia()

    new Vue({
      el: '#release-notes-page',
      pinia,
      components: {
        ReleaseNotesPage: defineAsyncComponent(() => import('@/modules/changelogs/ReleaseNotesPage.vue'))
      }
    })
  }

  if (document.getElementById('changelog-page')) {
    const pinia = createPinia()

    new Vue({
      el: '#changelog-page',
      pinia,
      components: {
        ChangelogPage: defineAsyncComponent(() => import('@/modules/changelogs/ChangelogPage.vue'))
      }
    })
  }

  if (document.getElementById('order-count-badge')) {
    new Vue({
      el: '#order-count-badge',
      components: {
        OrderCountBadge
      }
    })
  }

  if (document.getElementById('sidebar-bottom-nav')) {
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)

    new Vue({
      el: '#sidebar-bottom-nav',
      pinia,
      components: {
        SidebarBottomNav
      }
    })
  }
})
